import { IRankingOutputDto } from './ranking-output-dto.interface';

export interface IKpiOutputDto {
    name: string;
    value?: number;
    label?: string;
    unit?: string;
    breakdown?: {
        label: string;
        value: number | null;
        unit?: string;
    }[];
    metadata?: Record<string, unknown>;
    period?: {
        start: Date;
        end: Date;
    };
    drilldown?: IRankingOutputDto[];
}
